import React, { useContext } from "react";
import { ProfileData } from "../../data/auth";

export interface AuthContextProps {
  user?: ProfileData;
  saveToken: (accessToken: string, refreshToken?: string, userData?: ProfileData) => void;
  updateInfo: (userData: ProfileData) => void;
  signOut: () => void;
  isAuthenticated: boolean;
}

export const AuthContext = React.createContext<AuthContextProps>({} as AuthContextProps);
